/** Regex mois civil métier U3207 (`yyyy-MM`). */
export const U3207_MONTH_REGEX = /^\d{4}-(0[1-9]|1[0-2])$/;

export function u3207IsValidMonthYm(ym: string): boolean {
  return U3207_MONTH_REGEX.test(ym);
}

/** Extrait `yyyy-MM` depuis un jour civil `yyyy-MM-dd`. */
export function u3207YmFromCivilYmd(ymd: string): string | null {
  if (!/^\d{4}-(0[1-9]|1[0-2])-\d{2}$/.test(ymd)) return null;
  return ymd.slice(0, 7);
}

/** Décale un mois civil `yyyy-MM` de `monthOffset` mois. */
export function u3207ShiftMonthYm(ym: string, monthOffset: number): string | null {
  if (!u3207IsValidMonthYm(ym)) return null;
  const year = Number(ym.slice(0, 4));
  const month = Number(ym.slice(5, 7));
  const total = year * 12 + (month - 1) + monthOffset;
  const nextYear = Math.floor(total / 12);
  const nextMonth = (total % 12) + 1;
  if (nextYear < 1 || nextYear > 9999) return null;
  return `${String(nextYear).padStart(4, '0')}-${String(nextMonth).padStart(2, '0')}`;
}
